// extracted by mini-css-extract-plugin
export default {"riskDetailsTable":"hK4Bzd4nhl0aFaaWhVhO","risMmetricsContainer":"ONWHgq4Fzh70ST38n1P5","riskMetricsTable":"ShFkJ8xmo6rVouYut1kS"};